<style scoped="scoped">
@import '../../../../assets/css/common.css';
</style>
<style scoped="scoped">
  .mobileregister{
    font-family:"SourceHanSansCN-Regular";
    font-size: 12px;
    color: #333333;
  }
  .mobileregister .devredister_title{
    padding: 20px 0 20px;
    font-size:22px;
    letter-spacing: 2px;
    text-align: center;
    font-weight:600;
    color:rgba(51,51,51,1);
  }
  .mobileregister .devredister-content .devredister_form_wrapper{
    width: 90%;
    margin: 0 auto;
    text-align: right;
  }
  .mobileregister .devredister-content .devredister_form_wrapper .devredister_btn {
    color: #FFFEFE;
    width: calc(100% - 20px);
    height: 40px;
    background: rgba(16, 142, 233, 1);
    border-radius: 6px;
    border-color: transparent;
    margin-bottom: 20px;
  }
  .mobileregister .devredister-content  .sendcode {
    color:#108EE9!important;
    font-size:14px;
    font-weight:400;
    background: transparent;
    position: absolute;
    top: 7px;
    text-align: right;
    right: 10px;
  }
  .mobileregister .devredister-content .sendcode.is-disabled{
    color:#999999!important;
  }
  .mobileregister .devredister-content .image-code-item{
    position: relative;
  }
  .mobileregister .devredister-content .image-code-img{
    width: 120px;
    height: 34px;
    position: absolute;
    top: 3px;
    right: 10px;
    border-radius: 4px;
    cursor: pointer;
  }
  .mobileregister .devredister-content .protocol{
    color: #999999;
    text-align: left;
    margin-bottom: 22px;
    padding-left: 20px;
  }
  .mobileregister .devredister-content .protocol>a{
    color: #108EE9;
    text-decoration: none;
    cursor: pointer;
  }
</style>
<style type="text/css">
  .mobileregister .devredister-content .protocol .el-checkbox__input.is-checked+.el-checkbox__label{
    color: #999999;
  }
  .mobileregister .devredister-content .protocol .el-checkbox__label{
    color: #999999;
  }
  .mobileregister .login-now{
    width: 100%;
    display: inline-block;
    text-align: right;
    font-size:12px;
    color:rgba(51,51,51,1);
    margin-bottom: 20px;
  }
  .mobileregister .login-now a{
    font-size:12px;
    font-family:MicrosoftYaHei;
    font-weight:400;
    color:rgba(16,142,233,1);
    text-decoration: none;
    cursor: pointer;
  }
  .mobileregister .devredister-content   .el-form-item.is-success .el-input__inner,
  .mobileregister .devredister-content   .el-form-item.is-success .el-textarea__inner{
    border-color:#D6D6D6;
  }
  .mobileregister .devredister-content  .el-form-item .el-input__inner:focus,
  .mobileregister .devredister-content   .el-form-item .el-textarea__inner:focus{
    background:rgba(255,255,255,1);
    border:1px solid rgba(16,142,233,1);
    box-shadow:0px 0px 10px 0px rgba(16,142,233,0.3);
    border-radius:6px;
  }
  .mobileregister .devredister-content .el-input--prefix .el-input__inner{
    padding-left: 35px;
  }
  .mobileregister .devredister-content  .validcode span.el-input__prefix{
    line-height:40px;
  }
  .mobileregister .el-form-item{
    margin-bottom:20px;
  }
  .mobileregister .devredister-content .el-checkbox__input.is-checked .el-checkbox__inner,
  .mobileregister .devredister-content .el-checkbox__inner:hover,
  .mobileregister .devredister-content .el-checkbox__inner:focus,
  .mobileregister .devredister-content .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: transparent;
    border-color: #999999;
  }
  .mobileregister .devredister-content .el-checkbox__input.is-checked .el-checkbox__inner::after{
    color: #999999;
    border-color: #999999;
  }
  .mobileregister .devredister-content .el-checkbox__inner{
    border-color: #999999;
  }
</style>
<template>
  <div class="mobileregister">
    <header class="mobilehead">
      <el-row>
        <el-col :span="4"><div style="padding-left:8px" @click="clickLogin"><img src="../../../../assets/images/icon/back.png" /></div></el-col>
        <el-col :span="16"><div class="tlc">开发者注册</div></el-col>
        <el-col :span="4"><div></div></el-col>
      </el-row>
    </header>
    <div class="devredister-content">
      <div class="devredister_title">开发者注册</div>
      <div class="devredister_form_wrapper">
        <el-form :model="devredisterForm" ref="devredisterForm" :rules="rules" label-width="20px" class="devredisterform">
          <el-form-item label=" " prop="mobile">
            <el-input v-model.trim="devredisterForm.mobile" autocomplete="off" placeholder="手机号" :maxlength="20" clearable>
              <i slot="prefix" class="el-input__icon icon-my-user"></i>
            </el-input>
          </el-form-item>
          <el-form-item label=" " prop="imageCode" class="image-code-item">
            <el-input v-model.trim="devredisterForm.imageCode" autocomplete="off" placeholder="图形验证码" :maxlength="10" clearable>
              <i slot="prefix" class="el-input__icon icon-my-validcode"></i>
            </el-input>
            <img class="image-code-img" :src="imageCodeSrc" @click="refreshImageCode">
          </el-form-item>
          <el-form-item label=" " prop="smsCode">
            <el-input v-model.trim="devredisterForm.smsCode" autocomplete="off" placeholder="验证码" :maxlength="10">
              <i slot="prefix" class="el-input__icon icon-my-validcode"></i>
            </el-input>
            <el-button class="sendcode" @click="sendCode" :disabled="!show" type="text">{{ showCount }}</el-button>
          </el-form-item>
          <el-form-item label=" " prop="password">
            <el-input type="password" v-model.trim="devredisterForm.password" autocomplete="off" placeholder="设置密码" :maxlength="100" clearable>
              <i slot="prefix" class="el-input__icon icon-my-password"></i>
            </el-input>
          </el-form-item>
          <el-form-item label=" " prop="confirmPassword">
            <el-input type="password" v-model.trim="devredisterForm.confirmPassword" autocomplete="off" placeholder="确认密码" :maxlength="100" clearable>
              <i slot="prefix" class="el-input__icon icon-my-password"></i>
            </el-input>
          </el-form-item>
          <el-form-item label=" " prop="businessContact">
            <el-input v-model.trim="devredisterForm.businessContact" autocomplete="off" placeholder="业务联系人" :maxlength="32" clearable>
              <i slot="prefix" class="el-input__icon icon-my-link"></i>
            </el-input>
          </el-form-item>
          <el-form-item label=" " prop="contactNumber">
            <el-input v-model.trim="devredisterForm.contactNumber" autocomplete="off" placeholder="联系电话" :maxlength="100" clearable>
              <i slot="prefix" class="el-input__icon icon-my-phone"></i>
            </el-input>
          </el-form-item>
          <el-form-item label=" ">
            <el-input v-model.trim="devredisterForm.companyName" autocomplete="off" placeholder="公司名称" :maxlength="100" clearable>
              <i slot="prefix" class="el-input__icon icon-my-company"></i>
            </el-input>
          </el-form-item>
          <el-form-item label=" ">
            <el-input v-model.trim="devredisterForm.companyWebsiteAddress" autocomplete="off" placeholder="公司网址" :maxlength="200" clearable>
              <i slot="prefix" class="el-input__icon icon-my-web"></i>
            </el-input>
          </el-form-item>
        </el-form>
        <div class="protocol"><el-checkbox v-model="checked">我已阅读并同意</el-checkbox><a @click="viewProtocol()">《开发者协议》</a></div>
        <el-button class="devredister_btn" @click="submitForm('devredisterForm')" @keyup.enter.native="submitForm('devredisterForm')">提交</el-button>
        <div class="login-now"><a @click="$router.push({name:'mobileLogin'})">立即登录</a></div>
      </div>
    </div>
  </div>
</template>

<script>
import smsImageCodeMixin from '@/mixins/smsImageCodeMixin'
import commonService from '@/service/commonService'
export default {
  name: 'mobileRegister',
  mixins: [smsImageCodeMixin],
  data: function () {
    let validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      }
      if (value && (value.replace(/^\s+|\s+$/gm, '').length < 6 || value.replace(/^\s+|\s+$/gm, '').length > 18)) {
        callback(new Error('密码长度为6-18位'))
      }
      if (value !== this.devredisterForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      isShow: false,
      checked: true,
      devredisterForm: {
        mobile: '',
        imageCode: '',
        smsCode: '',
        password: '',
        confirmPassword: '',
        businessContact: '',
        contactNumber: '',
        companyName: '',
        companyWebsiteAddress: ''
      },
      rules: {
        mobile: [
          { required: true, message: '请输入登录手机号码', trigger: 'blur' },
          { validator: this.$rules.phoneNumber, trigger: 'blur' }
        ],
        imageCode: [
          { required: true, message: '请输入图形验证码', trigger: 'blur' }
        ],
        password: [{ required: true, message: '请输入正确密码', trigger: 'blur' }],
        businessContact: [{ required: true, message: '请输入业务联系人', trigger: 'blur' }],
        smsCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        contactNumber: [
          { required: true, message: '请输入业务联系电话', trigger: 'blur' },
          {validator: this.$rules.telephoneNumber, trigger: 'blur'}
        ],
        confirmPassword: [
          { required: true, message: '请输入正确密码', trigger: 'blur' },
          { validator: validatePass2, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    clickLogin () {
      this.pagedefault = ''
      this.$router.push({name: 'fronthome'})
      this.$nextTick(() => {
        this.pagedefault = '/'
      })
    },
    async sendCode () {
      await this.sendSmsCodeWithImage()
    },
    submitForm (formName) {
      if (!this.checked) {
        this.$message.error({ message: '请认真阅读开发者协议', customClass: 'errmsg' })
        return true
      }
      this.$refs[formName].validate(async valid => {
        if (valid) {
          try {
            this.$cookie.set('deviceId', this.devredisterForm.mobile)
            delete this.devredisterForm.confirmPassword
            await commonService.devredister(this.devredisterForm)
            this.$router.push({name: 'mobileLogin'})
          } catch (e) {
            this.$message.error({ message: e && e.msg, customClass: 'errmsg' })
          }
        } else {
          this.$message.error({ message: '请认真检查填写信息', customClass: 'errmsg' })
          return false
        }
      })
    },
    forgetPwd () {
      this.$router.push({name: 'mobileForgetpsw'})
    },
    viewProtocol () {
      let routeData = this.$router.resolve({name: 'mobileAgreement'})
      window.open(routeData.href, '_blank')
    },
    handleScroll () {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      this.isShow = scrollTop > 300
    },
    toTop () {
      let distanceY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      this.interval = setInterval(() => {
        if (distanceY - 60 > 0) {
          distanceY -= 60
          window.scrollTo(0, distanceY)
        } else {
          window.scrollTo(0, 0)
          clearInterval(this.interval)
        }
      }, 10)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/front/mobile-page/mobileregister/index.vue